var map = {
	"./el.json": [
		9932,
		932
	],
	"./en-GB.json": [
		2508,
		508
	],
	"./en.json": [
		7854,
		854
	],
	"./pt.json": [
		3293,
		293
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80;
module.exports = webpackAsyncContext;